
import React, { useState, useEffect, useRef } from 'react';
import {
    View,
    Image,
    ActivityIndicator,
    Text,
} from 'react-native';
import Colors from '../../constant/Colors';
import { getCachedUrlContent, getImageFromFirebaseStorage } from '../../util/commonFuncs';

const AsyncImage = props => {
    const {
        source,
        item,
        style,
        hideLoading,
        lazy,
    } = props;

    const [url, setUrl] = useState('');
    const [shouldLoad, setShouldLoad] = useState(!lazy);
    const placeholderRef = useRef(null);

    // useEffect(() => {
    //     if (source && source.uri) {
    //         if (source.uri.startsWith('http')) {
    //             setUrl(source.uri);
    //         }
    //         else {
    //             getImageFromFirebaseStorage(source.uri, (parsedUrl) => {
    //                 setUrl(parsedUrl);
    //             });

    //             // const urlTemp = retrieveImageFromFirebase(source);

    //             // setUrl(urlTemp);
    //         }
    //     }
    // }, [source]);

    // const retrieveImageFromFirebase = async (source) => {
    //     const urlTemp = await getImageFromFirebaseStorage(source.uri);

    //     return urlTemp;
    // };

    useEffect(() => {
        if (!lazy) return;
        if (shouldLoad) return;
        if (typeof window === 'undefined' || typeof window.IntersectionObserver === 'undefined') {
            setShouldLoad(true);
            return;
        }
        const node = placeholderRef.current;
        if (!node) {
            setShouldLoad(true);
            return;
        }
        const observer = new window.IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    setShouldLoad(true);
                    observer.disconnect();
                    break;
                }
            }
        }, { rootMargin: '400px 0px' });
        observer.observe(node);
        return () => observer.disconnect();
    }, [lazy, shouldLoad]);

    useEffect(() => {
        if (!shouldLoad) return;
        loadCachedImage(source, item);
    }, [source, item, shouldLoad]);

    const loadCachedImage = async (source, item) => {
        if (source && source.uri) {
            if (source.uri.startsWith('http') || source.uri.startsWith('file:///')) {
                setUrl(source.uri);
            }
            else {
                // console.log('to retrieve uri');
                // console.log(source.uri);

                if (source.uri[0] === '/') {
                    const cachedObj = await getCachedUrlContent(source.uri, 43800, item);

                    if (cachedObj && cachedObj.parsedUrl) {
                        setUrl(cachedObj.parsedUrl);
                    }

                    // if (cachedImgUrl) {
                    //     setUrl(cachedImgUrl);
                    // }   
                    // else {
                    //     getImageFromFirebaseStorage(source.uri, async (parsedUrl) => {
                    //         setUrl(parsedUrl);
                    //     });
                    // }
                }
            }
        } else {
            // if there is no source then reset
            setUrl('')
        }
    }

    // Extract numeric width/height from style for the img tag
    const imgWidth = style && style.width ? (typeof style.width === 'number' ? style.width : undefined) : undefined;
    const imgHeight = style && style.height ? (typeof style.height === 'number' ? style.height : undefined) : undefined;

    return (
        <>
            {(url !== '' || hideLoading) ?
                <img
                    loading="lazy"
                    decoding="async"
                    src={url}
                    width={imgWidth}
                    height={imgHeight}
                    style={{
                        ...(style && style.width !== undefined && { width: typeof style.width === 'number' ? style.width + 'px' : style.width }),
                        ...(style && style.height !== undefined && { height: typeof style.height === 'number' ? style.height + 'px' : style.height }),
                        ...(style && style.borderRadius !== undefined && { borderRadius: typeof style.borderRadius === 'number' ? style.borderRadius + 'px' : style.borderRadius }),
                        objectFit: 'cover',
                    }}
                />
                :
                <View ref={placeholderRef} style={[{
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                }, style]}>
                    {shouldLoad ? <ActivityIndicator color={Colors.primaryColor} size={"large"} /> : null}
                </View>
            }
        </>
    );
};

export default AsyncImage;